"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Returns the user's locale
 *
 * @since 15.0.0
 */
function getLocale() {
    return OC.getLocale();
}
exports.getLocale = getLocale;
/**
 * Translate a string
 *
 * @param {String} app the id of the app for which to translate the string
 * @param {String} text the string to translate
 * @param {Object} vars map of placeholder key to value
 * @param {Number} number to replace %n with
 * @param {OC.L10N.TranslationOptions} [options] options object
 * @return {String}
 *
 * @since 15.0.0
 */
function translate(app, text, vars, count, options) {
    return OC.L10N.translate(app, text, vars, count, options);
}
exports.translate = translate;
/**
 * Translate a plural string
 *
 * @param {string} app the id of the app for which to translate the string
 * @param {string} textSingular the string to translate for exactly one object
 * @param {string} textPlural the string to translate for n objects
 * @param {number} count number to determine whether to use singular or plural
 * @param {Object} vars of placeholder key to value
 * @param {OC.L10N.TranslationOptions} options options object
 * @return {String}
 *
 * @since 15.0.0
 */
function translatePlural(app, textSingular, textPlural, count, vars, options) {
    return OC.L10N.translatePlural(app, textSingular, textPlural, count, vars, options);
}
exports.translatePlural = translatePlural;
